import Model from '@/core/models/Model';
import Gender from '@/models/Gender';
import type { Gender as IGender } from '@/types/Misc';

class GenderService {
  get() {
    return useAsyncData<IGender[]>(
      'genders',
      async () => {
        return Model.processResponse(await Gender.get()) as IGender[];
      },
      { server: false }
    );
  }
}

export default new GenderService();
